import { css, polished, Immutable } from 'jimu-core';
const toCSSTextUnderLine = (text) => {
    if (!text) {
        return 'none';
    }
    if (text.underline && text.strike) {
        return 'underline line-through';
    }
    else if (text.underline) {
        return 'underline';
    }
    else if (text.strike) {
        return 'line-through';
    }
    return 'none';
};
/** get common styles for an HTML element as a CSS basic box model */
export function getBoxStyles(variables) {
    var _a, _b;
    return variables && css `
    color: ${variables.color};
    background-color: ${variables.bg};
    ${variables.border && css `
      border-width: ${variables.border.width};
      ${variables.border.width && `border-style: ${(_b = (_a = variables.border) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'solid'};`}
      border-color: ${variables.border.color};
    `}
    border-radius: ${variables.borderRadius};
    box-shadow: ${variables.shadow};
    font-weight: ${variables.bold ? 'bold' : variables.fontWeight};
    text-decoration: ${variables.decoration || toCSSTextUnderLine(variables)};
    font-style: ${variables.italic ? 'italic' : 'normal'};
  `;
}
/** get common interpolation styles for an HTML element as a CSS basic box model */
export function getBoxInterpolationStyles(variables) {
    var _a, _b;
    return variables && `
    color: ${variables.color};
    background-color: ${variables.bg};
    ${variables.border && `
      border-width: ${variables.border.width};
      ${variables.border.width && `border-style: ${(_b = (_a = variables.border) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'solid'};`}
      border-color: ${variables.border.color};
    `}
    border-radius: ${variables.borderRadius};
    box-shadow: ${variables.shadow};
    font-weight: ${variables.bold ? 'bold' : variables.fontWeight};
    text-decoration: ${variables.decoration || toCSSTextUnderLine(variables)};
    font-style: ${variables.italic ? 'italic' : 'normal'};
  `;
}
const RotationMapping = {
    up: '180deg',
    down: null,
    left: '90deg',
    right: '-90deg'
};
export function caret(direction) {
    const rotationDeg = RotationMapping[direction];
    return `
    ${rotationDeg && `
      transform: rotate(${rotationDeg});
    `}
  `;
}
export function hover(content) {
    return `
    &:hover {
      ${content}
    }
  `;
}
export function hoverFocus(content) {
    return `
    &:hover,
    &:focus {
      ${content}
    }
  `;
}
export function navDivider(color, margin) {
    return `
    height: 0;
    margin: ${margin};
    overflow: hidden;
    border-top: 1px solid ${color};
  `;
}
export function formValidation(isValid, theme) {
    const stateColor = theme && theme.colors
        ? isValid ? theme.colors.success : theme.colors.danger
        : isValid ? 'green' : 'red';
    const baseClassName = isValid ? 'valid' : 'invalid';
    return css `
  &.is-${baseClassName} {
    border-color: ${stateColor || (isValid ? 'green' : 'red')};
    ${!isValid && `background: ${polished.rgba(stateColor, 0.1)}`};
  }
  `;
}
export const createFocusedStyles = (colors) => {
    return Immutable({
        color: colors.palette.primary[700],
        width: '2px',
        offset: '2px'
    });
};
export * from './pointer';
export * from './coloration';
